// The public booking link is now a guided stepper. Add ?legacy=1 to the address to open the
// original single-page (accordion) layout instead - same fields, rules and payments, so it can
// be compared or used as a fallback. Delete this switch (and the legacy layout) once signed off.
export const wantsLegacyPublicForm = () => {
  try {
    return new URLSearchParams(window.location.search).get("legacy") === "1";
  } catch (e) {
    return false;
  }
};
